<template>
  <div class="page-container">
    <div class="query-title">发货运费结算查询</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="导出" @click="exportPage" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template #settlementNo="{row}">
              <el-link type="primary" @click="showDialog(row)">{{ row.settlementNo }}</el-link>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

    <el-dialog
      v-dialogDrag
      :visible.sync="dialog"
      title="发货运费结算查看"
      width="85%"
    >
      <delivery-fee-check v-if="dialog" :row-data="currentRow" />
    </el-dialog>
  </div>
</template>

<script>
import DeliveryFeeCheck from './components/DeliveryFeeCheck1.vue'
import { apiFindDeliverySettlement } from '@/api/applyForGoods/logisticsAbnormal'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/deliveryFeeSearch'

import { frontExport, concurrencyReq } from '@/utils/frontExport'
export default {
  components: {
    DeliveryFeeCheck
  },
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      dialog: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [],
        data: []
      },
      pageSearch,
      searchField: {},
      isSetFilter: false
    }
  },
  created() {
    this.initPage(pageConfig)
    this.tableSort.push({ field_name: 'createdDate', field_sort: 'X' })
  },
  methods: {
    async exportPage() {
      const params = {
        ...this.allConditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, apiFindDeliverySettlement)
      frontExport(this.gridOptions.columns, data, '发货运费结算')
    },
    showDialog(row) {
      this.currentRow = row
      this.dialog = true
    },
    toDetail(code) {
      this.$router.push({
        path: '/wly/master-data-client/client-edit',
        query: {
          code
        }
      })
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data: { Rows, Total }, calculation, field } = await apiFindDeliverySettlement(params)
        if (Rows.length === 0 && Total) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = Total - 0
        this.calculation = this.filtercalculation(calculation, 'xTable', true)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(Rows)
        } else {
          this.gridOptions.data = Rows.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field, 'xTable', true)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/apply-for-manage/data-searching/deliveryFeeSearch.vue